export const filterInputs = [
  {
    advanced: false,
    type: 'input',
    id: 'name',
    label: 'Nome',
    placeholder: 'Nome',
    value: ''
  }
];